import React from 'react';
import formatAmount from '../../../../utils/FormetAmount.js';

const PnLCard = ({
    type,
    amount,
    color = 'bg-blue-500',
    gradient = 'from-[#EFF6FF] to-[#ffff]',
    icon,
    className = '',
    onClick,
    colSpan = 2
}) => {
    return (
        <div
            className={`col-span-${colSpan} rounded-2xl p-3 shadow-md border border-white bg-gradient-to-tl ${gradient} ${className} ${onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''}`}
            onClick={onClick}
        >
            <div className="flex items-center">
                <div className={`p-2 ${color} rounded-[10px] flex items-center justify-center mr-2`}>
                    {icon}
                </div>
                <div>
                    <h3 className="text-xs font-bold text-gray-700 mb-0.5 leading-5">{type}</h3>
                    <div className="text-sm font-bold text-gray-900">${formatAmount(amount || 0)}</div>
                </div>
            </div>
        </div>
    );
};

export default PnLCard;